import type { ContentTypeDto } from "$src/core/models/dto";
import Ga4Service from "$src/core/services/analytics/ga4";

export type DefaultParams = {
  screen_name: string;
};

export type Event =
  | {
      name: "login";
      result: "successful" | "error";
    }
  | {
      name: "logout";
      result: "successful" | "error";
    }
  | {
      name: "register";
      result: "successful" | "error";
    }
  | {
      name: "screen_view";
      screen_name: string;
      screen_route: string;
    }
  | {
      name: "button_interaction";
      button_name?: string;
      button_type?: string;
      button_label?: string;
    }
  | {
      name: "search";
      search_type?: "search_query" | "search_suggestion" | "search_history";
      search_query?: string;
    }
  | {
      name: "content_streaming";
      streaming_method?: "local" | "airplay" | "chromecast";
      streaming_action?: "start" | "stop" | "connection_lost";
      content_type?: "live" | "vod";
      content_title?: string;
      content_duration?: number;
    }
  | {
      name: "content_interaction";
      interaction_type?: "start" | "stop" | "pause" | "fastforward" | "rewind";
      content_title?: string;
      content_type?: "live" | "vod";
      content_duration?: number;
    }
  | {
      name: "content_view";
      content_id: string;
      content_type: ContentTypeDto;
      content_title?: string;
    }
  | {
      name: "error";
      error_type: string;
      error_message: string;
      error_code?: string;
    }
  | {
      name: "watchlist_add";
      content_id: string;
      content_type: ContentTypeDto;
      content_title?: string;
    }
  | {
      name: "watchlist_remove";
      content_id: string;
      content_type: ContentTypeDto;
      content_title?: string;
    };

export type AnalyticsService<T extends AnalyticsConfig> = {
  init: (config: T) => void;
  trackEvent: (event: Event & Partial<DefaultParams>) => void;
  setUserProperty: (name: string, value: string) => void;
};

export type AnalyticsConfig =
  | {
      type: "ga4";
      measurementId?: string;
      enabled?: boolean;
    }
  | {
      type: string;
      [key: string]: unknown;
    };

const Analytics: AnalyticsService<AnalyticsConfig> = Ga4Service;

export default Analytics;
